import { registerComponent } from '@gig/magic-common';
import MessagesComponent from './messages.vue.js';

var Messages = registerComponent(MessagesComponent);

export { Messages };
